import React from "react";
import { Main } from "./Main";
import { Footer } from "./Footer";

const App = () => {
    return (
        <div>
            <Main />
            <Footer />
        </div>
    )
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js